export default __webpack_public_path__ + "static/media/3.d785b0df.jpg";